/** Idempotency keys for real-fire sends (2026-07-23 audit item).
 *
 * One key per DRAFT, not per click: the key is minted at the first send
 * attempt and kept until the server confirms — so a retry after a timeout
 * (user re-clicks, or backendFetch's wake retry) re-sends the SAME key and
 * the server delivers exactly once. On confirmed success the caller clears
 * the key; the next draft gets a fresh one. */
export function newIdemKey(): string {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  } catch { /* older engines */ }
  return "ik_" + Math.random().toString(36).slice(2) + "_" + Math.random().toString(36).slice(2);
}
